export const errorMapper: Record<string, string> = {
    conflict: 'El código ya se encuentra registrado',
    server_error: 'Error interno. Inténtalo más tarde',
};
